import React, { useEffect } from "react";

import EINChurchPageV1 from "../../component/pages/products/EINChurchPage";
import EINChurchPageV2 from "../../V2/components/pages/products/EINChurchPage";

function EINChurch() {
  const isV2 = process.env.NEXT_PUBLIC_REACT_APP_SKIN === "taxnumber" 
  || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid"
  || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein"
  || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1"
  || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2"
  || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3"
  || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4";

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "klaviyo";
    document.body.appendChild(script);
    script.appendChild(
      document.createTextNode(
        "var _learnq = _learnq || [];" +
        "var item = {" +
        "      \"ProductName\": \"Church Organization\"," +
        "      \"ProductID\": \"EIN_Church\"," +
        "      \"Categories\": [\"EIN\"]" +
        "};" +
        "_learnq.push([\"track\", \"Viewed Product\", item]);"
      )
    );
    return () => {
      if (document.getElementById("klaviyo")) {
        document.body.removeChild(document.getElementById("klaviyo"));
      }
    };
  }, []);
  
  if (isV2) {
    return (
      <EINChurchPageV2 />
    )
  }

  return (
    <EINChurchPageV1 />
  );
}

export default EINChurch;
